import useSWR from 'swr';
import { API_HOST } from '../helpers/constants';
import { fetcher } from '../utils';

export function useLender(id) {
  const url = `${API_HOST}/lenders/${id}`;

  const { data: responseData, error, isLoading, mutate } = useSWR(id ? url : null, fetcher);

  const revalidate = () => mutate(url);

  return {
    lender: responseData,
    isLoading,
    isError: error,
    revalidate
  };
}
